import { useState } from 'react';
import cn from 'classnames';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import image from '@/openMarket/ui/assets/noAccess/openMarketNoAccess.webp';
import JoinWaitlistModal from '@/openMarket/ui/common/Finsight/JoinWaitlistModal';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader';
import { useProductGradient } from '@/creditflowresearch/ui/common/hooks/products/useProductGradient';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

import {
  OPEN_MARKET_PAGE_TITLE,
  openMarketNoAccessDescription,
  openMarketNoAccessFeatures,
  openMarketImageCaption,
} from './constants';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';

import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './comingSoon.module.scss';

const ComingSoon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { checkAccessByUserPlan } = useUserPlanContext();
  const panelBackground = useProductGradient();

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <PageContentLayout>
      <ProductPageHeader
        title="OpenMarket (Closed Beta)"
        withoutProductTitle
        blockingAccessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }] }
        panelBackground={ panelBackground }
      />
      <NoAccessOverlay
        title={ OPEN_MARKET_PAGE_TITLE }
        description={ openMarketNoAccessDescription }
        features={ openMarketNoAccessFeatures }
        imageCaption={ openMarketImageCaption }
        image={ image.src }
        customButton={ () => (
          <Button
            dataTest="joinWaitingListButton"
            variant={ ButtonVariantType.action }
            onClick={ openModal }
            className={ styles.actionButton }
          >
            Join Waiting List
          </Button>
        ) }
      />
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
      <JoinWaitlistModal closeModal={ () => setIsModalOpen(false) } isOpen={ isModalOpen } />
    </PageContentLayout>
  );
};

export default ComingSoon;
